import { render, staticRenderFns } from "./Stripo.vue?vue&type=template&id=4187e566&"
import script from "./Stripo.vue?vue&type=script&lang=js&"
export * from "./Stripo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports